<template>
    <div>
        <div class="device-box r200-bg">
            <h3 class="device-name reveal-bottom">D100-AWL5</h3>
            <p class="device-desc reveal-bottom">{{ $t("dv.dtt") }}</p>
            <img class="r200-img reveal-bottom" :src="r200" alt="r200" />
        </div>
        <div
            class="device-box bg-fixed"
            :style="{
                backgroundImage: 'url(' + bg2 + ')',
            }"
        >
            <div class="wrap">
                <div class="device-title reveal-bottom">
                    {{ $t("dv.dt1") }}<br />
                    {{ $t("dv.dt2") }}
                </div>
                <div class="device-char">
                    <div class="device-char-item reveal-bottom">
                        <img
                            :src="intro2"
                            alt="intro1"
                            class="device-char-icon"
                            style="height:50px"
                        />
                        <div class="device-char-desc">
                            <h4 class="device-chart-desc-titl">
                                {{ $t("dv.rd1") }}
                            </h4>
                            <div class="device-chart-desc-cont">
                                40<span style="font-size:18px">Mbps</span>
                            </div>
                        </div>
                    </div>
                    <div
                        class="device-char-item reveal-bottom"
                        style="width:229px;"
                    >
                        <img
                            :src="intro3"
                            alt="intro1"
                            class="device-char-icon"
                            style="height:50px"
                        />
                        <div class="device-char-desc">
                            <h4 class="device-chart-desc-titl">
                                {{ $t("dv.rd2") }}
                            </h4>
                            <div class="device-chart-desc-cont">
                                1<span style="font-size:18px">Gbps</span>
                            </div>
                        </div>
                    </div>
                    <div class="device-char-item reveal-bottom">
                        <img
                            :src="intro4"
                            alt="intro1"
                            class="device-char-icon"
                            style="height:50px"
                        />
                        <div class="device-char-desc">
                            <h4 class="device-chart-desc-titl">
                                {{ $t("dv.rd3") }}
                            </h4>
                            <div class="device-chart-desc-cont">
                                324mm * 190mm * 44mm
                            </div>
                            <div class="device-chart-desc-detail"></div>
                        </div>
                    </div>
                    <div
                        class="device-char-item reveal-bottom"
                        style="width:250px"
                    >
                        <img
                            :src="intro6"
                            alt="intro1"
                            class="device-char-icon"
                            style="height:50px"
                        />
                        <div class="device-char-desc">
                            <h4 class="device-chart-desc-titl">
                                {{ $t("dv.rd4") }}
                            </h4>

                            <div class="device-chart-desc-detail">
                                Type C x1<br />
                                USB2.0 x1<br />
                                Gbps RJ45 x5<br />
                                5G x1<br />
                                LTE({{ $t("dv.rxesim") }}) x1
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="device-box">
            <div class="card-box reveal-bottom">
                <div class="card  r200">
                    <div class="card-head">
                        <div class="card-head-left">
                            <span>{{ $t("dv.ry") }}</span>
                            <div></div>
                        </div>
                        <div class="card-no">1</div>
                    </div>
                    <div
                        class="card-text"
                        :style="lang === 'en_US' ? 'font-size:25px' : ''"
                    >
                        {{ $t("dv.dy") }}<br />{{ $t("dv.ryc1") }}
                    </div>
                </div>
                <div class="card r200">
                    <div class="card-head">
                        <div class="card-head-left">
                            <span>{{ $t("dv.ru") }}</span>
                            <div></div>
                        </div>
                        <div class="card-no">2</div>
                    </div>
                    <div
                        class="card-text"
                        :style="lang === 'en_US' ? 'font-size:25px' : ''"
                    >
                        100 {{ $t("dv.rxu") }}
                    </div>
                </div>
                <div class="card r200">
                    <div class="card-head">
                        <div class="card-head-left">
                            <span>{{ $t("dv.ra") }}</span>
                            <div></div>
                        </div>
                        <div class="card-no">3</div>
                    </div>
                    <div
                        class="card-text"
                        :style="lang === 'en_US' ? 'font-size:25px' : ''"
                    >
                        {{ $t("dv.dac") }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import initAnimation from "../animation";
export default {
    name: "R200",
    data() {
        return {
            lang: localStorage.getItem("lang"),
            bg2: require("@/assets/images/devices/A55_bg.jpg"),
            r200: require("@/assets/images/devices/D100-AWL5.png"),
            intro1: require("@/assets/images/devices/R200_intro1.png"),
            intro2: require("@/assets/images/devices/R200_intro2.png"),
            intro3: require("@/assets/images/devices/R200_intro3.png"),
            intro4: require("@/assets/images/devices/R200_intro4.png"),
            intro5: require("@/assets/images/devices/R200_intro5.png"),
            intro6: require("@/assets/images/devices/R200_intro6.png"),
        };
    },
    mounted() {
        setTimeout(initAnimation, 0);
        this.$bus.$on("lang", (lang) => {
            this.lang = lang;
        });
    },
};
</script>
<style scoped>
@import "./devices.css";
.r200-img {
    width: 600px;
    /* height: 496px; */
    margin: 85px auto 0;
    display: block;
}
.r200-bg {
    background: linear-gradient(left top, #aaf37e, #46bb00);
}
.r200:hover {
    background-color: #46bb00;
    transition: all 0.3s ease;
}
</style>



// WEBPACK FOOTER //
// src/Pages/Hardware/D100AWL5.vue